import { Modal } from '@/components/common/dialog';
import { ModalButton } from '@/components/common/modal-button';
import { useConfigStore } from '@/stores/configStore';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { AppUtils } from '@/utils/app';

interface HelpPopupProps {
    isOpen: boolean;
    onClose: () => void;
}

export function HelpPopup({ isOpen, onClose }: HelpPopupProps) {
    const { t } = useTranslation();
    const { config } = useConfigStore();

    return (
        <Modal isOpen={isOpen} onClose={onClose} className="max-w-[calc(680*var(--vw-unit))]">
            <h1 className={clsx(styles.helpModal__title)}>
                <span data-modal-region tabIndex={0} data-interactive aria-label={t('employeeHelp.header')} className="focus-border">
                    {t('employeeHelp.header')}
                </span>
            </h1>
            <div className={styles.helpModal__contentContainer}>
                <p
                    tabIndex={0}
                    className={clsx(styles.helpModal__description, 'text-text-main01', 'focus-border')}
                    data-interactive
                    aria-label={t('employeeHelp.descriptionTTS')}
                    dangerouslySetInnerHTML={{ __html: t('employeeHelp.description') }}
                >
                </p>
                <div
                    tabIndex={0}
                    className={clsx(config.ui.contrast ? styles['helpModal__phoneContainer--contrast'] : styles['helpModal__phoneContainer'], 'focus-border')}
                    data-interactive
                    aria-label={t('employeeHelp.phoneLabel') + ' ' + AppUtils.getPhoneNumberTTSText(t('employeeHelp.phoneNumber'))}
                >
                    <span className={config.ui.contrast ? styles['helpModal__phoneLabel--contrast'] : styles.helpModal__phoneLabel}>
                        {t('employeeHelp.phoneLabel')}
                    </span>
                    <span className={clsx('number', config.ui.contrast ? styles['helpModal__phoneNumber--contrast'] : styles.helpModal__phoneNumber)}>
                        {t('employeeHelp.phoneNumber')}
                    </span>
                </div>
            </div>

            <div className={styles.helpModal__buttonContainer}>
                <ModalButton
                    role="button"
                    variant="secondary"
                    onClick={onClose}
                    data-interactive
                    aria-label={t('employeeHelp.text.confirmButton')}
                    type="button"
                >
                    {t('employeeHelp.text.confirmButton')}
                </ModalButton>
            </div>
        </Modal>
    );
}
